import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ProgressBarMode } from '@angular/material/progress-bar';

@Component({
    selector: 'app-long-running-operation-status',
    templateUrl: './app-long-running-operation-status.html',
    styleUrls: ['./app-long-running-operation-status.css'],
    standalone: false
})
export class LongRunningOperationComponent implements OnInit {

  title;
  message;
  progress = 0;
  progressMode: ProgressBarMode = 'query';
  status = 1;
  

  constructor(public dialogRef: MatDialogRef<LongRunningOperationComponent>) {}

  ngOnInit() {
  }

}
